import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import React from "react";
import StatusComponent from "./StatusComponent";
import {useTranslation} from "i18nano";
import {preventDefaultOnDropFiles} from "../helpers/stubFunctions";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {CommonProps} from "./types/types";
import {Choice} from "../api/types/Choice";

import {withSharedMemo} from "./memo/memoComponent";
import DisplayTextComponent from "./DisplayTextComponent";

interface RadiosComponentProps extends CommonProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: React.FocusEventHandler<HTMLLabelElement>
    radioGroupName: string;
    choices: Choice[],
    other: boolean,
}

const RadiosComponent = ({
                             value,
                             onChange,
                             errorText = "",
                             onFocus,
                             status = StatusUpdateAnswer.NONE,
                             required, editable, displayText, radioGroupName, choices, other, id,
                             hint
                         }: RadiosComponentProps) => {
    const t = useTranslation();
    return (
        <FormControl disabled={!editable} required={required}
                     error={errorText !== ""}>
            <div style={{display: "flex"}}>
                <FormLabel required={false}>
                    <DisplayTextComponent text={displayText} required={required} hint={hint}/>
                </FormLabel>
                <StatusComponent status={status}/>
            </div>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name={radioGroupName}
                value={value}
                onChange={onChange}
                id={id}
                className={"widthMaxContent"}
            >
                {
                    choices?.map(choice => {
                        return (
                            <FormControlLabel onFocus={onFocus} key={choice.id}
                                              name={`${choice.id}`}
                                              value={choice.id} control={<Radio/>}
                                              className={"textWrap"}
                                              onKeyPress={e => {
                                                  if (value !== `${choice.id}`) {
                                                      if (e.key === "Enter") {
                                                          const ev = {
                                                              target: {value: choice.id.toString()}
                                                          }
                                                          //@ts-ignore
                                                          onChange(ev);
                                                      }
                                                  }
                                              }}
                                              label={choice.text === null || choice.text === "" ? "(empty)" : choice.text}/>
                        )
                    })
                }
                {other === true ?
                    <FormControlLabel onFocus={onFocus}
                                      disabled={!editable}
                                      value={"Other"}
                                      checked={value === "Other" || value.indexOf("o:") !== -1}
                                      control={<Radio/>} label={t("Other")}
                                      onKeyPress={e => {
                                          if (value.indexOf("o:") === -1) {
                                              if (e.key === "Enter") {
                                                  const ev = {
                                                      target: {value: "Other"}
                                                  }
                                                  //@ts-ignore
                                                  onChange(ev);
                                              }
                                          }
                                      }}

                    />
                    : null}
            </RadioGroup>
            {
                value === "Other" || value.indexOf("o:") !== -1
                    ?
                    <TextField error={errorText !== ""} value={value.substring(2)}
                               onChange={e => {
                                   e.target.value = `o:${e.target.value}`;
                                   onChange(e as React.ChangeEvent<HTMLInputElement>);
                               }} label="Other"
                               variant="outlined"
                               disabled={!editable}
                               InputProps={{
                                   endAdornment: <InputAdornment position="end">
                                       <StatusComponent status={status}/>
                                   </InputAdornment>,
                               }}
                               onDrop={preventDefaultOnDropFiles}
                    />
                    : null
            }
            {errorText !== "" ? <FormHelperText error>{errorText}</FormHelperText> : null}
        </FormControl>
    )
}

export default withSharedMemo(RadiosComponent);